
<template>
  <transition :enter-active-class="enterClass" :leave-active-class="leaveClass">
    <component
      id="current-slide"
      v-if="showSlide"
      :is="activeTemplate"
      :step="step"
      :slide="slide"
      :theme="theme"
      :metaData="metaData || {}"
      :editing="false"
      :demo="demo === true"
      :event="event"
      :secondsLeft="secondsLeft"
      :preview="preview || false"
      :showLogo="showLogo"
      :userView="userView === true"
      :moderatorView="moderatorView === true"
      :useLocalSteps="useLocalSteps === true"
      :frozenScreenshot="frozenScreenshot || false"
      :recap="recap || false"
      :avatarPreviews="avatarPreviews || false"
      :eventSettings="eventSettings || {}"
      :addNewItem="addNewItem || false"
      :forceShowLogo="activeTemplate === 'joinSlide' ? forceShowJoinSlideLogo || false : false"
    />
  </transition>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import SlidePresentControls from '~/components/mixins/SlidePresentControls'

export default {
  name: 'SlideContainer',
  components: {
    'joinSlide': () => import('~/components/slides/JoinSlide'),
    'titleSlide': () => import('~/components/slides/TitleSlide'),
    'contentSlide': () => import('~/components/slides/ContentSlide'),
    'gridContentSlide': () => import('~/components/slides/GridContentSlide'),
    'multipleChoice': () => import('~/components/slides/MultipleChoice'),
    'userVote': () => import('~/components/slides/UserVote'),
    'scoreSummary': () => import('~/components/slides/ScoreSummary'),
    'passTheMic': () => import('~/components/slides/PassTheMic'),
    'ratingSlide': () => import('~/components/slides/RatingSlide'),
    'pollSlide': () => import('~/components/slides/PollSlide'),
    'specificTextAnswer': () => import('~/components/slides/SpecificTextAnswer'),
    'answerSummary': () => import('~/components/slides/AnswerSummary'),
    'wordCloud': () => import('~/components/slides/WordCloud'),
    'imageShare': () => import('~/components/slides/ImageShare'),
    'powerPoint': () => import('~/components/slides/PowerPointSlide')
  },
  mixins: [
    SlidePresentControls
  ],
  props: [
    'slide',
    'preview',
    'theme',
    'template',
    'event',
    'secondsLeft',
    'userView',
    'moderatorView',
    'useLocalSteps',
    'demo',
    'frozenScreenshot',
    'recap',
    'metaData',
    'showLogo',
    'avatarPreviews',
    'eventSettings',
    'forceShowJoinSlideLogo',
    'addNewItem'
  ],
  computed: {
    activeTemplate () {
      const slide = this.slide || {}
      return slide.template || this.template || 'titleSlide'
    },
    enterClass () {
      // no transition if it's part of a navigation list
      if (this.$parent.$options.name === 'slick-item') { return '' }
      return 'animated ' + this.enterTransition
    },
    leaveClass () {
      // no transition if it's part of a navigation list
      if (this.$parent.$options.name === 'slick-item') { return '' }

      return 'animated ' + this.leaveTransition
    }
  }
}
</script>
